export const LEXICAL_TYPES = [
  'vocabulary',
  'phrase',
  'collocation',
  'phrasal_verb',
  'idiom',
  'pattern',
] as const

export type LexicalType = typeof LEXICAL_TYPES[number]

export const LEXICAL_TYPE_LABELS: Record<LexicalType, string> = {
  vocabulary: 'Từ vựng',
  phrase: 'Cụm từ',
  collocation: 'Collocation',
  phrasal_verb: 'Phrasal verb',
  idiom: 'Thành ngữ',
  pattern: 'Mẫu câu',
}

export interface Lexical {
  id: string
  text: string
  type: LexicalType
  translations: Record<string, string>
  phonemes: string | null
  audio: string | null
  image: string | null
}

export type LexicalInput = Omit<Lexical, 'id'>

export interface LexicalListResponse {
  success: boolean
  data: Lexical[]
  pagination?: { page: number; size: number; total: number }
  message?: string
}

export interface LexicalResponse {
  success: boolean
  data?: Lexical
  message?: string
}
